module.exports = {
  DISPLAY_FORMAT: 'L',
  ISO_FORMAT: 'YYYY-MM-DD',

  START_DATE: 'startDate',
  END_DATE: 'endDate',

  HORIZONTAL_ORIENTATION: 'horizontal',
  VERTICAL_ORIENTATION: 'vertical'
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dates/constants.js
 ** module id = 771
 ** module chunks = 1
 **/